export default function fetchMenu(menuId, _params, containerProps) {
  const menus = containerProps.editorConfig?.globals?.menus;

  if (menus) {
    if (menus[menuId]) {
      return menus[menuId];
    }
    throw new Error(`Menu '${menuId}' not found`);
  }

  return null;
}
